<!-- فرم کدینگ اطلاعات -->
<template>
  <div class="row">
    <!-- منوهای بالای جدول اصلی -->
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <!-- جستجوی پیشرفته در لیست سرفصل حساب ها -->
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input
              id="textTbBaseAccSearch"
              placeholder="جستجو پیشرفته در لیست سرفصل حساب ها (Enter)"
              type="text"
              class="form-control form-control-sm rounded-0"
              v-on:focus="$event.target.select()"
              v-on:keyup.enter="filterData($event.target.value)"
            />
            <div class="input-group-prepend rounded-0">
              <span
                class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                "
              >
                <a v-on:click="filterData('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <!-- منوهای سمت چپ -->
        <div
          class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
        >
          <a
            class="
              btn btn-secondary btn-sm btn-floating
              p-0
              m-0
              d-flex
              justify-content-around
              align-items-center
            "
            style="width: 80px; height: 30px"
            title="کل جدید"
            data-toggle="modal" 
            v-bind:data-target="'#ModalAddNewBaseAcc-' + '0'"
            v-on:click="ShowModalAddNewBaseAcc"
          >
            <!-- v-on:click="addNewTab('AccDoc')" -->
            کل جدید
            <i class="far fa-clone fa-1x-half text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- جدول لیست سرفصل حساب ها -->
    <ShowTableBaseAcc
      :key="1"
      v-bind:ParentCode = "0"
      v-bind:ListTbBaseAccData="setListTbBaseAcc"
      v-bind:isMultieSelect="isMultieSelect"
      v-bind:ListAllShowFilter="ListAllShowFilter"
    ></ShowTableBaseAcc>
    <!-- مودال ثبت سرفصل حساب جدید -->
    <AddNewBaseAcc
      v-if="isShowAddNewBaseAcc == true"
      v-on:AddNewBaseAcc="HideModalAddNewBaseAcc"
      v-bind:ParentCode="0"
      v-bind:NewChildCode="NewChildCode"
      v-bind:NewNAccType="0"
      v-bind:Title1="'ثبت حساب کل جدید'"
      v-bind:Title2="''"
    >
    </AddNewBaseAcc>
  </div>
</template>

<script>
import ShowTableBaseAcc from "./Components/ShowTableBaseAcc.vue";
import AddNewBaseAcc from "./Components/AddNewBaseAcc.vue";
// import { BusEvent } from "../../../../main.js";

export default {
  name: 'ParentTable',
  components: {
    ShowTableBaseAcc,
    AddNewBaseAcc
  },
  data() {
    return {
      // لیست اصلی سرفصل حساب ها محلی
      ListTbBaseAcc: [],
      // لیست سطرهای در حال نمایش
      ListAllShowFilter: [],
      // کنترل نمایش مودال سرفصل حساب جدید
      isShowAddNewBaseAcc: false,
      // کد سرفصل حساب جدید
      NewChildCode: 0,
      // کنترل وضعیت چند انتخابی
      isMultieSelect: true
    };
  },
  created() {
      this.getListTbBaseAcc();
  },
  computed: {
    setListTbBaseAcc(){
      this.ListTbBaseAcc = this.$store.getters.getAllTbBaseAccData;
      return this.ListTbBaseAcc;
    },
  },
  methods: {
    // نمایش مودال درج سرفصل حساب جدید
    ShowModalAddNewBaseAcc(){
      this.NewChildCode = this.getLastChildCode();
      this.isShowAddNewBaseAcc = true;
    },
    // دریافت لیست سرفصل حساب ها از سرور
    async getListTbBaseAcc() {
        // دریافت اطلاعات کاربر جاری
        let token = await this.$store.getters.getUserData.token; // توکن کاربر
        let yearID = await this.$store.getters.getYearActive; // دریافت سال فعال
        // دریافت لیست حساب ها
        await this.$store.dispatch("getAllTbBaseAccDataFromSever", {
          yearID,
          token,
        });
    },
    // رویداد بسته شدن مودال ثبت سرفصل حساب جدید
    async HideModalAddNewBaseAcc(value){
        // مخفی کردن مودال ثبت سرفصل حساب جدید
        this.isShowAddNewBaseAcc = false;
        // خالی کردن لیست سطرهای در حال نمایش
        this.ListAllShowFilter.length = 0  
        // فراخوانی بازیابی مجدد اطلاعات
        this.getListTbBaseAcc();
    },
    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode(){
      let tempCode = 0;
      this.getListChildLevel1().forEach(element => {
        if(element.NCode > tempCode){
          tempCode = element.NCode
        }
      });
      if(parseInt(tempCode) > 0){
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / تفصیلی سه صفر یک
        return '110';
      }
    },
    // استخراج فرزندان سطح یک
    getListChildLevel1() {
      let tempData = [];
      if (this.ListTbBaseAcc.length > 0) {
        // حساب کل
        tempData = this.ListTbBaseAcc.filter(function (item) {
          return item.NCode.toString().length == 3;
        });
      }
      return tempData;
    },    

    // جستجو در لیست حساب ها
    filterData(searchValue, event) {
      // اگر دکمه جستجو کلیک شود
      if (searchValue === "Search") {
        searchValue =
          $("#textTbBaseAccSearch").val() != ""
            ? $("#textTbBaseAccSearch").val()
            : "";
      }

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        let ListTbBaseAccFilter =
          this.ListTbBaseAcc.filter(function(item){
            return (
                item.NCode.toString().startsWith(searchValue) ||
                item.SDesc.toString().includes(searchValue)
              )
            });
        if(ListTbBaseAccFilter.length > 0){
          // نمایش پیام تعداد جستجو
          this.$store.dispatch("notify", {
            notText: "به تعداد ( " + ListTbBaseAccFilter.length + " ) مورد پیدا شد .",
            color: "86ff3b",
            timeOut: 2500,
          });
          // ایجاد لیست سطرهای انتخاب شده و در حال نمایش
          this.ListAllShowFilter.length = 0  // خالی کردن لیست سطرهای در حال نمایش
          // متغییر محلی لیست سطرهای در حال نمایش
          let tempListShow = [];
          // متغییر محلی معادل لیست سرفصل ها
          let tempListTbBaseAcc = this.ListTbBaseAcc;  
          // اجرای حلقه به تعداد سطرهای جستجو شده
          ListTbBaseAccFilter.forEach(function(item){
            // استخراج تمام والدهای کد جستجو شده
            let listTemp = tempListTbBaseAcc.filter(function(value){
              // اگر کد برابر بود یا ابتدای کد برابر بود
              return value.NCode == item.NCode || 
              item.NCode.toString().startsWith(value.NCode)
            });
            // استخراج کد تمام والدها
            listTemp.forEach(function(val) { 
                if(tempListShow.findIndex((find) => find == val.NCode) == -1){
                  tempListShow.push(val.NCode)
                }
              });
          });

          this.ListAllShowFilter = tempListShow;
        } else {
          this.$store.dispatch("notify", {
            notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
            timeOut: 2500,
          });
        }
      } 
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseAcc/ListBaseAcc.vue